"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenSeadragon = useOpenSeadragon;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _openSeadragon = require("../open-seadragon");

var _useViewerState3 = require("./use-viewer-state");

var _useIsViewerReady3 = require("./use-is-viewer-ready");

function useOpenSeadragon() {
  var tileSources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var osdOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var osdRef = (0, _react.useRef)(null);

  var _useViewerState = (0, _useViewerState3.useViewerState)(),
      _useViewerState2 = (0, _slicedToArray2["default"])(_useViewerState, 2),
      viewer = _useViewerState2[0],
      setViewer = _useViewerState2[1];

  var _useIsViewerReady = (0, _useIsViewerReady3.useIsViewerReady)(viewer),
      _useIsViewerReady2 = (0, _slicedToArray2["default"])(_useIsViewerReady, 2),
      isReady = _useIsViewerReady2[0],
      setIsReady = _useIsViewerReady2[1];

  var asyncAddTile = (0, _react.useCallback)(function (options) {
    if (!options.tileSource) {
      options = {
        tileSource: options,
        index: 0
      };
    }

    return new Promise(function (_success, err) {
      if (!viewer) {
        return;
      }

      try {
        viewer.addTiledImage((0, _objectSpread2["default"])({}, options, {
          success: function success(item) {
            _success();

            if (options.success) {
              options.success(item);
            }
          }
        }));
      } catch (e) {
        err(e);
      }
    });
  }, [viewer]);
  var goHome = (0, _react.useCallback)(function () {
    if (viewer) {
      viewer.viewport.goHome(true);
    }
  }, [viewer]);
  (0, _react.useLayoutEffect)(function () {
    setViewer(new _openSeadragon.OpenSeadragon((0, _objectSpread2["default"])({
      element: osdRef.current,
      // Hide controls by default, since user must add path to UI to
      // render images.
      showSequenceControl: false,
      showNavigationControl: false,
      showZoomControl: false,
      showHomeControl: false,
      showFullPageControl: false
    }, osdOptions))); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setViewer]); // @todo if the OSD options change, how do you re-apply them?

  (0, _react.useLayoutEffect)(function () {
    if (viewer) {
      var tileSourcesArray = Array.isArray(tileSources) ? tileSources : [tileSources];
      Promise.all(tileSourcesArray.map(function (tileSource) {
        return asyncAddTile(tileSource);
      })).then(goHome);
    }

    return function () {
      if (viewer) {
        setIsReady(false);
        viewer.close();
      }
    };
  }, [asyncAddTile, goHome, setIsReady, tileSources, viewer]);
  return [osdRef, {
    isReady: isReady,
    goHome: goHome,
    asyncAddTile: asyncAddTile,
    viewer: viewer
  }];
}